import './App.css';
import Header from './layouts/Header';
import MainContent from './layouts/MainContent';
import Footer from './layouts/Footer';

function App() {
  return (
    <div className="App">
      <Header />
      <MainContent />
      <Footer />
    </div>
  );
}

export default App;
